var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_86_1106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.121 28.2421H27.1921V9.22989C27.1921 8.7445 26.7986 8.35098 26.3132 8.35098H21.6369C21.1515 8.35098 20.758 8.7445 20.758 9.22989V28.2421H18.7435V12.2108C18.7435 11.7254 18.35 11.3319 17.8646 11.3319H13.1883C12.703 11.3319 12.3094 11.7254 12.3094 12.2108V28.2421H10.295V14.5956C10.295 14.1102 9.90148 13.7167 9.4161 13.7167H4.73992C4.25453 13.7167 3.86102 14.1102 3.86102 14.5956V28.2421H1.75781V0.878903C1.75781 0.393514 1.36429 0 0.878903 0C0.393514 0 0 0.393514 0 0.878903V29.121C0 29.6064 0.393514 29.9999 0.878903 29.9999H29.121C29.6064 29.9999 29.9999 29.6064 29.9999 29.121C29.9999 28.6356 29.6064 28.2421 29.121 28.2421ZM22.5158 10.1088H25.4343V28.2421H22.5158V10.1088ZM14.0673 13.0897H16.9858V28.2421H14.0673V13.0897ZM5.61883 15.4745H8.53725V28.2421H5.61883V15.4745Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.73886 8.89825C4.81293 8.89823 4.88669 8.88883 4.95841 8.87031L24.467 3.85312L23.9441 4.73313C23.6962 5.15038 23.8334 5.68967 24.2507 5.9377C24.3862 6.0185 24.541 6.06114 24.6988 6.0611C24.9987 6.0611 25.2909 5.90758 25.4552 5.63102L27.0667 2.91908C27.1261 2.81915 27.1651 2.70844 27.1814 2.59335C27.1977 2.47826 27.191 2.36108 27.1617 2.24859C27.1324 2.13611 27.0811 2.03055 27.0107 1.93804C26.9403 1.84553 26.8523 1.7679 26.7517 1.70965L24.0049 0.118484C23.5849 -0.124737 23.0472 0.0184653 22.8039 0.438464C22.5606 0.858462 22.7038 1.39623 23.1239 1.63951L24.0133 2.15478L4.52054 7.16793C4.05044 7.28881 3.76738 7.76793 3.88826 8.23808C3.99027 8.63476 4.34734 8.89825 4.73886 8.89825Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_86_1106"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnalytics);
export default __webpack_public_path__ + "static/media/icon-analytics.73663feb0777ba8a32a6195954dd25b2.svg";
export { ForwardRef as ReactComponent };